
if (!customElements.get('trenday-product-story')) {
  customElements.define('trenday-product-story', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const control = event.target.closest('[data-story-prev], [data-story-next]');
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        if (control) {
          const slides = document.getElementById(control.getAttribute('aria-controls'));
          slides?.scrollBy({left: slides.clientWidth * (control.hasAttribute('data-story-prev') ? -1 : 1), behavior});
        }
        if (event.target.closest('[data-trenday-buy]')) {
          const form = document.querySelector('form[data-type="add-to-cart-form"]');
          const target = form?.closest('product-info') || form;
          target?.scrollIntoView({behavior, block: 'center'});
        }
      });
    }
  });
}

// Let King Product Options own its controls while the native picker updates media and prices.
if (!window.trendayOptionsBridge) {
  window.trendayOptionsBridge = true;
  const seen = new WeakSet();
  const nativeControl = (select) => {
    const index = select.name.match(/^ymq-option(\d+)$/)?.[1];
    const info = select.closest('product-info');
    const group = info?.querySelector(`variant-picker [data-option-index="option${index}"]`);
    return {info, group};
  };
  const initialize = () => {
    document.querySelectorAll('product-info select.ymq-shopify-option').forEach(select => {
      if (seen.has(select)) return;
      seen.add(select);
      const {group} = nativeControl(select);
      const control = group?.querySelector('input:checked, select');
      if (control && [...select.options].some(option => option.value === control.value)) {
        select.value = control.value;
        select.dispatchEvent(new Event('change', {bubbles: true}));
      }
    });
  };
  document.addEventListener('change', event => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('.ymq-shopify-option')) return;
    const {group} = nativeControl(select);
    const radio = [...(group?.querySelectorAll('input[type="radio"]') || [])].find(input => input.value === select.value);
    const dropdown = group?.matches('select') ? group : group?.querySelector('select');
    if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', {bubbles: true})); }
    else if (dropdown && dropdown.value !== select.value) { dropdown.value = select.value; dropdown.dispatchEvent(new Event('change', {bubbles: true})); }
  });
  new MutationObserver(initialize).observe(document.documentElement, {childList: true, subtree: true});
  initialize();
}
